<template>
    <div class="max-w-screen-xl mx-auto mt-16 md:mt-20 px-4">
        <h2 class="text-center mx-auto max-w-6xl text-2xl md:text-3xl " v-html="dataLocale.data.title">

        </h2>
        <div class="mt-12">
            <LayoutsSectionRowTemplate :order-odd="true">
                <template #description>
                    <div class="mb-6" v-for="post in multiDataLocale.data">
                        <h3 class="text-lg sm:text-xl font-semibold" :class="{ 'font-inter font-bold md:text-2xl': locale == 'vi' }">{{
                            post.title }}</h3>
                        <div class="mt-3 text-base">
                            {{ post.description }}
                        </div>
                    </div>
                </template>
                <template #image>
                    <nuxt-img loading="lazy" src="/customize.png" format="webp" alt="marketing-campaigns" class="mx-auto" height="420px" />
                </template>
            </LayoutsSectionRowTemplate>
        </div>
    </div>
</template>
<script lang="ts" setup>
import DataLocale from '~~/config/interface/DataLocale';
import MultiDataLocale from '~~/config/interface/MultiDataLocale';

const { locale } = useI18n()
const dataLocale = new DataLocale([
    {
        locale: "en",
        title: 'Everything You Need <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">For a Marketing <span class="down-mark-line">Campaign</span></span>'
    },
    {
        locale: "vi",
        title: 'Mọi thứ bạn cần <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">cho chiến dịch <span class="down-mark-line">tiếp thị</span></span>'
    },
    {
        locale: "es",
        title: 'Todo lo que necesitas <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">para una <span class="down-mark-line">campaña</span> de marketing</span>'
    },
    {
        locale: "de",
        title: 'Alles, was Sie brauchen <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">für eine <span class="down-mark-line">Marketing-Kampagne</span></span>'
    },
    {
        locale: "fr",
        title: 'Tout ce dont vous avez besoin <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">pour une <span class="down-mark-line">campagne</span> de marketing</span>'
    },
    {
        locale: "it",
        title: 'Tutto ciò di cui hai bisogno <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">per una <span class="down-mark-line">campagna</span> di marketing</span>'
    },
    {
        locale: "nl",
        title: 'Alles wat je nodig hebt <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">voor een <span class="down-mark-line">marketingcampagne</span></span>'
    },
    {
        locale: "ja",
        title: 'マーケティング<span class="down-mark-line">キャンペーン</span>に必要なすべて<span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4"></span>'
    },
    {
        locale: "zh",
        title: '您所需要的一切 <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">为一次营销<span class="down-mark-line">活动</span>准备</span>'
    },
    {
        locale: "pt",
        title: 'Tudo o que você precisa <span class="block text-success text-2xl sm:text-3xl md:text-5xl mt-4">para uma <span class="down-mark-line">campanha</span> de marketing</span>'
    }
])
const multiDataLocale = new MultiDataLocale([
    {
        locale: 'en',
        data: [
            {
                title: "Enhance Your QR Code Appeal by Adding a Logo or Image",
                description: "Why settle for a plain QR code when you can create a stunning visual QR code that incorporates your brand's logo or image? Our visual QR codes will make your marketing materials stand out, and are a powerful tool for boosting your brand identity."
            },
            {
                title: "Track Your Marketing Success with Real-Time Data",
                description: "Want to know if your marketing campaigns are hitting the mark? Our dynamic QR codes offer real-time data tracking, allowing you to monitor the success of your campaigns and make adjustments as needed. With this powerful tool, you'll be able to fine-tune your marketing efforts for maximum impact."
            },
            {
                title: "Edit Your QR Code with Ease",
                description: "Don't waste time and money printing new QR codes every time you need to make a change. Our dynamic visual QR codes can be easily edited, allowing you to update the URL with just a few clicks. Say goodbye to the hassle of reprinting and hello to the convenience of editable QR codes."
            }
        ]
    },
    {
        locale: "vi",
        data: [
            {
                "title": "Nâng cao sự hấp dẫn của mã QR bằng cách thêm logo hoặc hình ảnh",
                "description": "Tại sao phải chấp nhận mã QR đơn giản khi bạn có thể tạo ra một mã QR đẹp mắt kết hợp với logo hoặc hình ảnh của thương hiệu của bạn? Các mã QR của chúng tôi sẽ giúp cho tài liệu tiếp thị của bạn nổi bật hơn và là một công cụ mạnh mẽ để nâng cao danh tiếng thương hiệu của bạn."
            },
            {
                "title": "Theo dõi sự thành công của chiến dịch tiếp thị với dữ liệu thời gian thực",
                "description": "Bạn muốn biết liệu chiến dịch tiếp thị của mình có hiệu quả hay không? Các mã QR động của chúng tôi cung cấp theo dõi dữ liệu thời gian thực, cho phép bạn theo dõi sự thành công của chiến dịch của mình và điều chỉnh khi cần thiết. Với công cụ mạnh mẽ này, bạn có thể điều chỉnh chiến dịch tiếp thị của mình để đạt hiệu quả tối đa."
            },
            {
                "title": "Chỉnh sửa mã QR của bạn dễ dàng",
                "description": "Đừng lãng phí thời gian và tiền bạc để in mã QR mới mỗi khi bạn cần thay đổi. Các mã QR động của chúng tôi có thể được chỉnh sửa dễ dàng, cho phép bạn cập nhật URL chỉ bằng vài cú nhấp chuột. Hãy nói lời tạm biệt với sự phiền toái của việc in lại và chào đón sự tiện lợi của mã QR có thể chỉnh sửa được."
            }
        ]
    },
    {
        locale: "es",
        data: [
            {
                "title": "Mejora el atractivo de tu código QR agregando un logo o imagen",
                "description": "¿Por qué conformarte con un simple código QR cuando puedes crear un impresionante código QR visual que incorpora el logo o imagen de tu marca? Nuestros códigos QR visuales destacarán tus materiales de marketing y son una herramienta poderosa para impulsar la identidad de tu marca."
            },
            {
                "title": "Realiza un seguimiento del éxito de tu marketing con datos en tiempo real",
                "description": "¿Quieres saber si tus campañas de marketing están funcionando bien? Nuestros códigos QR dinámicos ofrecen un seguimiento de datos en tiempo real, lo que te permite monitorizar el éxito de tus campañas y hacer ajustes según sea necesario. Con esta poderosa herramienta, podrás ajustar tus esfuerzos de marketing para lograr el máximo impacto."
            },
            {
                "title": "Edita tu código QR con facilidad",
                "description": "No pierdas tiempo y dinero imprimiendo nuevos códigos QR cada vez que necesites hacer un cambio. Nuestros códigos QR visuales dinámicos se pueden editar fácilmente, lo que te permite actualizar la URL con solo unos pocos clics. Di adiós a la molestia de reimprimir y hola a la comodidad de los códigos QR editables."
            }
        ]
    },
    {
        locale: "de",
        data: [
            {
                "title": "Verbessern Sie die Attraktivität Ihres QR-Codes, indem Sie ein Logo oder Bild hinzufügen",
                "description": "Warum sich mit einem einfachen QR-Code zufrieden geben, wenn Sie einen beeindruckenden visuellen QR-Code erstellen können, der das Logo oder Bild Ihrer Marke integriert? Unsere visuellen QR-Codes lassen Ihre Marketingmaterialien herausstechen und sind ein mächtiges Werkzeug zur Stärkung Ihrer Markenidentität."
            },
            {
                "title": "Verfolgen Sie den Erfolg Ihrer Marketingkampagnen mit Echtzeitdaten",
                "description": "Möchten Sie wissen, ob Ihre Marketingkampagnen erfolgreich sind? Unsere dynamischen QR-Codes bieten Echtzeitdatenverfolgung und ermöglichen es Ihnen, den Erfolg Ihrer Kampagnen zu überwachen und bei Bedarf Anpassungen vorzunehmen. Mit diesem mächtigen Werkzeug können Sie Ihre Marketingbemühungen feinabstimmen, um maximale Auswirkungen zu erzielen."
            },
            {
                "title": "Bearbeiten Sie Ihren QR-Code mit Leichtigkeit",
                "description": "Verschwenden Sie keine Zeit und kein Geld damit, jedes Mal neue QR-Codes zu drucken, wenn Sie eine Änderung vornehmen müssen. Unsere dynamischen visuellen QR-Codes können leicht bearbeitet werden, so dass Sie die URL mit nur wenigen Klicks aktualisieren können. Verabschieden Sie sich von der lästigen Neudruckerei und sagen Sie hallo zur Bequemlichkeit von editierbaren QR-Codes."
            }
        ]
    },
    {
        locale: "fr",
        data: [
            {
                "title": "Améliorez l'attrait de votre code QR en ajoutant un logo ou une image",
                "description": "Pourquoi vous contenter d'un simple code QR alors que vous pouvez créer un code QR visuel époustouflant qui intègre le logo ou l'image de votre marque ? Nos codes QR visuels feront ressortir vos supports marketing et sont un outil puissant pour renforcer l'identité de votre marque."
            },
            {
                "title": "Suivez le succès de votre marketing avec des données en temps réel",
                "description": "Vous voulez savoir si vos campagnes marketing portent leurs fruits ? Nos codes QR dynamiques offrent un suivi des données en temps réel, vous permettant de surveiller le succès de vos campagnes et d'apporter des ajustements au besoin. Avec cet outil puissant, vous pourrez affiner vos efforts marketing pour un impact maximal."
            },
            {
                "title": "Modifiez facilement votre code QR",
                "description": "Ne perdez pas de temps et d'argent à imprimer de nouveaux codes QR à chaque fois que vous avez besoin de faire une modification. Nos codes QR visuels dynamiques peuvent être facilement modifiés, vous permettant de mettre à jour l'URL en quelques clics seulement. Dites adieu aux tracas de la réimpression et bonjour à la commodité des codes QR modifiables."
            }
        ]
    },
    {
        locale: "it",
        data: [
            {
                "title": "Migliora l'attrattiva del tuo codice QR aggiungendo un logo o un'immagine",
                "description": "Perché accontentarsi di un codice QR semplice quando puoi creare uno straordinario codice QR visivo che incorpora il logo o l'immagine del tuo marchio? I nostri codici QR visivi faranno risaltare i tuoi materiali di marketing e sono uno strumento potente per migliorare l'identità del tuo marchio."
            },
            {
                "title": "Tieni traccia del successo del tuo marketing con i dati in tempo reale",
                "description": "Vuoi sapere se le tue campagne di marketing stanno raggiungendo gli obiettivi? I nostri codici QR dinamici offrono il tracciamento dei dati in tempo reale, consentendoti di monitorare il successo delle tue campagne e apportare le modifiche necessarie. Con questo strumento potente, sarai in grado di perfezionare i tuoi sforzi di marketing per massimizzare l'impatto."
            },
            {
                "title": "Modifica il tuo codice QR con facilità",
                "description": "Non sprecare tempo e denaro per stampare nuovi codici QR ogni volta che devi apportare una modifica. I nostri codici QR visivi dinamici possono essere facilmente modificati, consentendoti di aggiornare l'URL con pochi clic. Dì addio alla seccatura della ristampa e saluta la comodità dei codici QR modificabili."
            }
        ]
    },
    {
        locale: "nl",
        data: [
            {
                "title": "Verbeter de aantrekkingskracht van uw QR-code door een logo of afbeelding toe te voegen",
                "description": "Waarom genoegen nemen met een gewone QR-code als u een verbluffende visuele QR-code kunt creëren die het logo of de afbeelding van uw merk bevat? Onze visuele QR-codes zullen uw marketingmateriaal doen opvallen en zijn een krachtig middel om uw merkidentiteit te versterken."
            },
            {
                "title": "Volg het succes van uw marketing met real-time gegevens",
                "description": "Wilt u weten of uw marketingcampagnes aanslaan? Onze dynamische QR-codes bieden real-time gegevens bijhouden, zodat u het succes van uw campagnes kunt volgen en aanpassingen kunt maken indien nodig. Met deze krachtige tool kunt u uw marketinginspanningen fine-tunen voor maximale impact."
            },
            {
                "title": "Bewerk uw QR-code eenvoudig",
                "description": "Verspil geen tijd en geld aan het afdrukken van nieuwe QR-codes telkens wanneer u een wijziging moet aanbrengen. Onze dynamische visuele QR-codes kunnen eenvoudig worden bewerkt, zodat u de URL met slechts een paar klikken kunt bijwerken. Zeg vaarwel tegen de moeite van het opnieuw afdrukken en hallo tegen het gemak van bewerkbare QR-codes."
            }
        ]
    },
    {
        locale: "ja",
        data: [
            {
                "title": "「QRコードの魅力をアップさせるロゴや画像を追加しましょう」",
                "description": "ブランドのロゴや画像を取り入れた魅力的なビジュアルQRコードを作成することで、平凡なQRコードに満足する必要はありません。当社のビジュアルQRコードは、マーケティング資料を際立たせるとともに、ブランドアイデンティティを強化するための強力なツールです。"
            },
            {
                "title": "「リアルタイムデータでマーケティングの成功を追跡」",
                "description": "マーケティングキャンペーンが目標を達成しているかどうかを知りたいですか？当社の動的QRコードにはリアルタイムデータトラッキング機能があり、キャンペーンの成功をモニターし必要に応じて調整することができます。この強力なツールを使えば、マーケティング努力を最適化することができます。"
            },
            {
                "title": "「簡単にQRコードを編集」",
                "description": "変更するたびに新しいQRコードを印刷する時間や費用を無駄にしないでください。当社の動的ビジュアルQRコードは簡単に編集でき、数回のクリックでURLを更新できます。再印刷の手間からおさらばし、編集可能なQRコードの便利さを利用しましょう。"
            }
        ]
    },
    {
        locale: "pt",
        data: [
            {
                "title": "Melhore o apelo do seu código QR adicionando um logotipo ou imagem",
                "description": "Por que se contentar com um código QR simples quando você pode criar um impressionante código QR visual que incorpora o logotipo ou imagem da sua marca? Nossos códigos QR visuais destacarão seus materiais de marketing e são uma ferramenta poderosa para impulsionar a identidade da sua marca."
            },
            {
                "title": "Acompanhe o sucesso do seu marketing com dados em tempo real",
                "description": "Quer saber se suas campanhas de marketing estão atingindo o objetivo? Nossos códigos QR dinâmicos oferecem rastreamento de dados em tempo real, permitindo que você monitore o sucesso de suas campanhas e faça ajustes conforme necessário. Com essa ferramenta poderosa, você poderá ajustar seus esforços de marketing para obter o máximo impacto."
            },
            {
                "title": "Edite seu código QR com facilidade",
                "description": "Não perca tempo e dinheiro imprimindo novos códigos QR toda vez que precisar fazer uma mudança. Nossos códigos QR visuais dinâmicos podem ser facilmente editados, permitindo que você atualize o URL com apenas alguns cliques. Diga adeus ao incômodo de reimprimir e olá para a conveniência de códigos QR editáveis."
            }
        ]
    },
    {
        locale: "zh",
        data: [
            {
                "title": "通过添加标志或图像增强您的QR码吸引力",
                "description": "何必满足于普通的QR码，当您可以创建一个引人注目的可视QR码，将您的品牌标志或图像融入其中？我们的可视QR码将使您的营销材料脱颖而出，是提升品牌形象的强大工具。"
            },
            {
                "title": "实时跟踪营销成功",
                "description": "想知道您的营销活动是否有所成效吗？我们的动态QR码提供实时数据跟踪，使您能够监控营销活动的成功，并根据需要进行调整。有了这个强大的工具，您将能够微调营销策略，获得最大的影响。"
            },
            {
                "title": "轻松编辑您的QR码",
                "description": "每次需要更改时都不要浪费时间和金钱来打印新的QR码。我们的动态可视QR码可以轻松编辑，让您只需点击几下即可更新URL。告别重新印刷的麻烦，拥抱可编辑QR码的便利性。"
            }
        ]
    },
])
</script>